import { useEffect, useState } from "react";
import LicenseService from "../../services/LicensesService";
import List from "../List/List";
import Pagination from "../Pagination/Pagination";
import { capitalize } from "../../utils/string";
import { LOCALES } from "../Datetime/Datetime";
import { useTranslation } from "react-i18next";
import { TimeAgo } from "../TimeAgo/TimeAgo";

export function PricesByPeriod({ period, resourceId, resourceType = "feature", ...props }) {
   const [currentPage, setCurrentPage] = useState(1);
   const [maxPage, setMaxPage] = useState(5);
   const [isLoading, setIsLoading] = useState(true);
   const [prices, setPrices] = useState([]);
   const { t, i18n } = useTranslation();

   async function fetchPrices() {
      setIsLoading(true);
      const response =
         resourceType === 'feature' ?
            await LicenseService.getPaginatedFeaturePrices(
               currentPage,
               '',
               { collumnTitle: 'id', orderDirection: 'DESC' },
               resourceId,
               period,
            ) : await LicenseService.getPaginatedTypePrices(
               currentPage,
               '',
               { collumnTitle: 'id', orderDirection: 'DESC' },
               resourceId,
               period,
            );
      setPrices(response.data.items);
      setMaxPage(response.data.pagination.totalPages);
      setIsLoading(false);
   }

   useEffect(() => {
      fetchPrices();
   }, [
      currentPage,
      resourceId,
      period,
   ]);

   if (!isLoading && (!prices || prices.length === 0)) {
      return;
   }

   return (
      <div className="w-full mt-4!">
         <h1 className="text-(--textColor)! text-[15px]! mb-2! text-left w-full">Histórico de ajustes</h1>
         <div className="list-container list-visibility">
            <List
               selectableRows={false}
               isLoading={isLoading}
               collumsObjIndex={[
                  { collumnLabel: "Valor", index: "amount", type: "money" },
                  {
                     collumnLabel: "Inicio em",
                     index: "startDate",
                     type: "custom",
                     custom: ({ row }) => {
                        return (
                           <span className="inline-flex items-center">
                              {capitalize(new Date(`${row.startDate}${!row.startDate.includes(':') ? 'T00:00:00' : ''}`).toLocaleDateString(LOCALES[i18n.language], {
                                 timeZone: "America/Sao_Paulo",
                                 weekday: 'long',
                                 year: 'numeric',
                                 month: 'long',
                                 day: 'numeric'
                              }))}
                              <span className='text-xs! opacity-60! ml-1!'>
                                 (<TimeAgo date={new Date(`${row.startDate}${!row.startDate.includes(':') ? 'T00:00:00' : ''}`)} simple={true} showText={true} />)
                              </span>
                           </span>
                        );
                     }
                  },
               ]}
               data={prices}
            />
         </div>
         <Pagination
            rowsPerPage={50}
            maxPage={maxPage}
            changePage={(page) =>
               setCurrentPage(page)
            }
         />
      </div>
   );
}